module.exports = __webpack_public_path__ + "img/avatar0.925394ed.png";